var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.849609 9.39502C0.849609 5.79988 0.849609 4.00231 1.7063 2.70757C2.08886 2.12941 2.584 1.63427 3.16216 1.25171C4.4569 0.39502 6.25447 0.39502 9.84961 0.39502C13.4447 0.39502 15.2423 0.39502 16.5371 1.25171C17.1152 1.63427 17.6104 2.12941 17.9929 2.70757C18.8496 4.00231 18.8496 5.79988 18.8496 9.39502C18.8496 12.9902 18.8496 14.7877 17.9929 16.0825C17.6104 16.6606 17.1152 17.1558 16.5371 17.5383C15.2423 18.395 13.4447 18.395 9.84961 18.395C6.25447 18.395 4.4569 18.395 3.16216 17.5383C2.584 17.1558 2.08886 16.6606 1.7063 16.0825C0.849609 14.7877 0.849609 12.9902 0.849609 9.39502ZM14.5088 9.39525C14.5088 11.9686 12.4227 14.0547 9.84935 14.0547C7.27603 14.0547 5.18994 11.9686 5.18994 9.39525C5.18994 6.82193 7.27603 4.73584 9.84935 4.73584C12.4227 4.73584 14.5088 6.82193 14.5088 9.39525ZM9.84935 12.4783C11.552 12.4783 12.9324 11.0979 12.9324 9.39525C12.9324 7.69255 11.552 6.31225 9.84935 6.31225C8.14666 6.31225 6.76635 7.69255 6.76635 9.39525C6.76635 11.0979 8.14666 12.4783 9.84935 12.4783ZM14.693 5.59639C15.2976 5.59639 15.7878 5.10622 15.7878 4.50156C15.7878 3.89691 15.2976 3.40674 14.693 3.40674C14.0883 3.40674 13.5981 3.89691 13.5981 4.50156C13.5981 5.10622 14.0883 5.59639 14.693 5.59639Z",
    fill: "#024E82"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.edb017c3bb83f6112e76f7682e574a12.svg";
export { ForwardRef as ReactComponent };